import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CheckCompanyService {
  private _selectedCompany = new BehaviorSubject<string>(''); // valore iniziale
  selectedCompany$ = this._selectedCompany.asObservable(); // observable pubblico

  // metodo per aggiornare il valore
  setSelectedCompany(companyName: any) {
    this._selectedCompany.next(companyName);
  }

  // metodo per ottenere il valore corrente (sincrono)
  getSelectedCompany(): any {
    return this._selectedCompany.value;
  }
}
